/**
 * @ngdoc config
 * @memberof mercury.startup
 * @name ApplicationConfig
 * @description Set some of the configs for the applcation
 */
angular.module('mercury.startup')
.config(["$stateProvider", "$templateFactoryProvider", function($stateProvider, $templateFactoryProvider) {

  // When route states are being registered we hook into the registration and
  // attach some code that runs when the route is actually being evaluated that
  // will determine if the current company setup says the route should be
  // showing a placeholder page, or it's ok to show the normal one.
  //
  // The benefit of doing it this way is the 'real' url remains along with the
  // menu highlighting, but the main content of the app displays a placeholder.
  $stateProvider.decorator(
    'dynamicPlaceholderDecorator',
    function(state) {

      var originalTemplate = state.self.template;
      var originalTemplateUrl = state.self.templateUrl;
      delete state.self.template;
      delete state.self.templateUrl;

      // We don't support using state `template: ...` definitions because the
      // way we handle intercepting routes and showing placeholder pages only
      // works with the use of templateUrl. If you're here because you got an
      // error and want to use `tempate: ...` then change to using
      // `templateUrl: ...` instead or otherwise refactor all the placeholder
      // code :)
      if (originalTemplate) {
        console.error('Using template in a route definition isn\'t supported, but there is a template defined as "%s"', originalTemplate);
        throw new Error('invalid-route-definition');
      }

      /**
       * Helper that returns true if the company setup info (from User Session)
       * has said that the current route should show a placeholder.
       */
      function isPlaceholder(userinfo) {
        var stateInformation = userinfo.getStateInformation();
        // we only want to show placeholders if there is one specifically
        // configured, in all other cases it's safe to return false
        return stateInformation && stateInformation[state.self.name] && stateInformation[state.self.name].showPlaceholder;
      }

      /**
       * Determines if there is a specifically configured placeholder template
       * for the current route, or if not returns the default placholder template.
       */
      function getPlaceholderTemplate(userinfo) {
        return $templateFactoryProvider.$get().fromUrl(
          state.self.placeholder && state.self.placeholder.templateUrl ?
            state.self.placeholder.templateUrl :
            'modules/placeholders/' + userinfo.companyTier() + '.tpl.html'
        );
      }

      /**
       * Determines if there is a specifically configured placeholder controller
       * for the current route, or if not returns the default placeholder controller.
       */
      function getPlaceholderController() {
        return state.self.placeholder && state.self.placeholder.controller ?
          state.self.placeholder.controller :
          'DefaultPlaceholderCtrl';
      }

      // attach to the function evaluated by the router to determine what template to show
      state.self.templateProvider = function(userinfo) {
        return isPlaceholder(userinfo) ?
          getPlaceholderTemplate(userinfo) :
          $templateFactoryProvider.$get().fromUrl(originalTemplateUrl);
      };

      // attach to the function evaluated by the router to determine what controller to run
      state.self.controllerProvider = function($state, userinfo) {
        return isPlaceholder(userinfo) ?
          getPlaceholderController() :
          state.self.controller;
      };
    }
  );

}]);
